import {
  inferenceCapabilityPromptLabel,
  inferenceCapabilityPromptPlaceholder,
  inferenceCapabilityRequiresFileUpload,
  inferenceCapabilitySupportsStream,
  normalizeInferenceCapability
} from "./inference-capabilities.js";

export function findPlaygroundRoute(routes, routeID) {
  const targetID = String(routeID || "").trim();
  if (!targetID || !Array.isArray(routes)) {
    return null;
  }
  return routes.find((item) => item?.id === targetID) || null;
}

export function playgroundCapability(route) {
  return normalizeInferenceCapability(route?.capability_family);
}

export function playgroundSupportsStream(route) {
  return inferenceCapabilitySupportsStream(playgroundCapability(route));
}

export function playgroundRequiresFileUpload(route) {
  return inferenceCapabilityRequiresFileUpload(playgroundCapability(route));
}

export function playgroundPromptLabel(route) {
  return inferenceCapabilityPromptLabel(playgroundCapability(route));
}

export function playgroundPromptPlaceholder(route) {
  return inferenceCapabilityPromptPlaceholder(playgroundCapability(route));
}

export function selectedPlaygroundModel(route, draft) {
  return String(draft?.model || route?.default_model || "").trim();
}

export function playgroundSupportsImageResponseFormat(route, draft) {
  const capability = playgroundCapability(route);
  if (capability !== "image_generation") {
    return true;
  }
  const model = selectedPlaygroundModel(route, draft).toLowerCase();
  if (!model) {
    return true;
  }
  return !(model === "gpt-image-1" || model.startsWith("gpt-image"));
}

export function defaultPlaygroundFilename(capability, contentType) {
  const normalizedCapability = String(capability || "").trim();
  const normalizedContentType = String(contentType || "").trim().toLowerCase();
  if (normalizedCapability === "audio_speech") {
    if (normalizedContentType.includes("mpeg")) return "speech.mp3";
    if (normalizedContentType.includes("wav")) return "speech.wav";
    if (normalizedContentType.includes("ogg")) return "speech.ogg";
    return "speech.bin";
  }
  if (normalizedCapability === "image_generation") {
    return "image-generation.json";
  }
  return "download.bin";
}
